// extracted by mini-css-extract-plugin
export default {"fields":"DRla_T","time":"rJ4cRQ","mobile":"eCsWDP"};